import React from "react";
import { Dropdown } from "react-bootstrap";
import { IoChevronDown } from "react-icons/io5";

const DropDownButton = ({ actions = [], label = "Action" }) => {
    return (
        <div className="flex-grow-sm-0">
            <Dropdown>
                <Dropdown.Toggle
                    id="dropdown-button"
                    as="button"
                    className="btn btn-gray text-start w-100 d-flex align-items-center justify-content-between px-4 py-2 border-0 rounded-3 shadow-sm dropdownbtn"
                    bsPrefix="custom-dropdown"
                >
                    <span>{label}</span>
                    <IoChevronDown size={16} style={{ marginLeft: '8px', opacity: 0.7 }} />
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu w-100 bg-white fs-sm fw-semibold border-0 rounded-3 shadow-sm mt-2">
                    {actions.map((action, index) => (
                        <Dropdown.Item
                            key={index}
                            onClick={(e) => {
                                action.onClick && action.onClick(e);
                            }}
                            className="dropdown-item d-flex align-items-center gap-2 py-2"
                        >
                            {action.icon && (
                                typeof action.icon === 'string' ? (
                                    action.icon.startsWith('bi') ? (
                                        <i className={`${action.icon} icon-sm`}></i>
                                    ) : (
                                        <span className="icon-sm">{action.icon}</span>
                                    )
                                ) : (
                                    <span className="icon-sm">{action.icon}</span>
                                )
                            )}
                            <span>{action.label}</span>
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default DropDownButton;